import styled from 'styled-components';

const CursoredA = styled.a`
  cursor: pointer;
`;

export default CursoredA;
